import React from 'react';
import { useSelector } from 'react-redux';
import { PriceConvertor } from 'components';

export const CustomerPaymentFiltersInfo = ({}) => {
  const { customerPayments } = useSelector((state) => ({
    customerPayments: state.customerPayments.customerPayments,
  }));
  const MVB = customerPayments?.totals?.mvb;
  const BOA = customerPayments?.totals?.boa;
  const FFB = customerPayments?.totals?.ffb;
  const TOTAL = customerPayments?.totals?.total;

  return (
    <div style={{ margin: '12px 0' }}>
      <div className="flex-align-center" style={{ gap: 16 }}>
        <div className="customer-payment-info-wrapper">
          <p style={{ fontWeight: 600 }}>MVB</p>
          <div className="flex-align-center" style={{ gap: 12 }}>
            <div className="customer-payment-amount-box flex-align-center" style={{ background: '#E4F3FF' }}>
              <PriceConvertor price={MVB?.totalUsedAmount || 0} /> / <PriceConvertor price={MVB?.totalAmount || 0} />
            </div>
            <div className="customer-payment-amount-box" style={{ background: '#E4F3FF' }}>{MVB?.percent || 0}%</div>
          </div>
        </div>
        <div className="customer-payment-info-wrapper">
          <p style={{ fontWeight: 600 }}>BOA</p>
          <div className="flex-align-center" style={{ gap: 12 }}>
            <div className="customer-payment-amount-box" style={{ background: '#FFF7DE' }}>
              <PriceConvertor price={BOA?.totalUsedAmount || 0} /> / <PriceConvertor price={BOA?.totalAmount || 0} />
            </div>
            <div className="customer-payment-amount-box" style={{ background: '#FFF7DE' }}>{BOA?.percent || 0}%</div>
          </div>
        </div>
        <div className="customer-payment-info-wrapper">
          <p style={{ fontWeight: 600 }}>FFB</p>
          <div className="flex-align-center" style={{ gap: 12 }}>
            <div className="customer-payment-amount-box flex-align-center" style={{ background: '#F3E8FF' }}>
              <PriceConvertor price={FFB?.totalUsedAmount || 0} /> / <PriceConvertor price={FFB?.totalAmount || 0} />
            </div>
            <div className="customer-payment-amount-box" style={{ background: '#F3E8FF' }}>{FFB?.percent || 0}%</div>
          </div>
        </div>
        <div className="customer-payment-info-wrapper">
          <p style={{ fontWeight: 600 }}>Total</p>
          <div className="flex-align-center" style={{ gap: 12 }}>
            <div className="customer-payment-amount-box" style={{ background: '#E8F7E9' }}>
              <PriceConvertor price={TOTAL?.totalUsedAmount || 0} /> / <PriceConvertor price={TOTAL?.totalAmount || 0} />
            </div>
            <div className="customer-payment-amount-box" style={{ background: '#E8F7E9' }}>{TOTAL?.percent}%</div>
          </div>
        </div>
      </div>
    </div>
  );
};